// collection-search-submit.js
//
// Handles two issues with previous form/GET by overriding submit event
// 1. If search term changes, submit clears facets in URL querystring.
//   This ensures every facet selection returns 1 or more items.
// 2. If metadata search, submit without querystring parameter 'sin='.
//
// Currently, there's no UI to clear existing facet selections, stored in URL,
// if user searches using different term.
//
// Note: This code is temporary, anticipating redesign and
// use of web componets for faceted search.
//
// Note: Legagy code did a GET request using form data.
// As application/x-www-form-urlencoded content in a URL,
// spaces in querystring names and values get represented as '+'.
// Here choosing to keep the legacy +-for-space rather than %20.
// URLSearchParams() can be used
// f = new URLSearchParams('foo moo=you too');
// f.toString() => 'foo+moo=you+too'
//
// Note: There's previously no canonical order to querystring name/value pairs
// Implemented here: query=,sin=,and[]=,sort=,page=
//
// Note: The use of '[]' brackets to encode array values In GET/POST, 'array[]=',
// is a PHP convention.
// Until we radically change conventions, let's keep these unencoded in URLs.
//
// Note: Facet links do not encode the '[]' characters of the 'and[]=' querystring name
// Sort links do encode the '[]' characters to 'and%5B%5D='
// These should be made consistent and this comment removed when done so
// URLSearchParams() can NOT be used
// f = new URLSearchParams('foo[]=a&foo[]=b');
// f.toString() => 'foo%5B%5D=a&foo%5B%5D=b'
//
// Discussion needed about https://perishablepress.com/stop-using-unsafe-characters-in-urls/
// and reserved characters -- which should not be encoded.
// Best when figuring out next facet implementation
//
// Also adding list format: tile, list, listdetail to querystring
//
// eslint-disable-next-line import/no-named-as-default
import $ from '../util/jquery.js';

$(() => {
  const $form = $('.search-form--inside');
  if (!$form) {
    return;
  }
  // Ensure querystring value has '+' for space character, as in a form/GET
  const formURLEncode = (text) => {
    if (text) {
      return encodeURIComponent(text.trim()).replace(/%20/g, '+');
    }
    return '';
  };
  // Append name/value if value exists
  const appendIfExists = (searchParams, name, value) => {
    if (value) {
      searchParams.append(name, value);
    }
  };
  // Return unencoded name/encoded value
  const nameValueIfExists = (querystring, name, value) => {
    if (value) {
      return `${querystring ? '&' : ''}${name}=${value}`;
    }
    return '';
  };

  // Get initial values
  const queryStart = $form.find('.searchlist').val();
  const searchInStart = $form.find('[name="sin"]:checked').val();
  // eslint-disable-next-line compat/compat
  const paramsStart = new URLSearchParams(window.location.search.substring(1));

  $form.submit((e) => {
    e.preventDefault();
    // Get submitted values
    const query = $form.find('.searchlist').val();
    const searchIn = $form.find('[name="sin"]:checked').val();
    // Build querystring
    // eslint-disable-next-line compat/compat
    const params = new URLSearchParams();
    appendIfExists(params, 'query', query);
    appendIfExists(params, 'sin', searchIn);
    let querystring = params.toString();
    // If query and searchIn unchanged
    if (queryStart === query && searchInStart === searchIn) {
      // Add back existing facets
      for (const value of paramsStart.getAll('and[]')) {
        querystring += nameValueIfExists(
          querystring,
          'and[]',
          formURLEncode(value),
        );
      }
    }
    // Add back sort value, if any
    const sort = paramsStart.get('sort');
    querystring += nameValueIfExists(querystring, 'sort', formURLEncode(sort));

    if (querystring) {
      querystring = `?${querystring}`;
    }

    // Build and load URL
    const loc = window.location;
    window.location = `${loc.origin}${loc.pathname}${querystring}`;
  });
});
